module.exports = __webpack_public_path__ + "static/bg06-aed40948774ccc65c289eb6fd74b910c.webp";